import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=2cc62fa6&scoped=true&"
import script from "./SuccessPage.vue?vue&type=script&lang=js&"
export * from "./SuccessPage.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPage.vue?vue&type=style&index=0&id=2cc62fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc62fa6",
  null
  
)

export default component.exports